
import {defineComponent} from 'vue';
import TreeNode from '@ohrm/oxd/core/components/TreeView/TreeNode.vue';

export default defineComponent({
  name: 'oxd-tree-view',
  inheritAttrs: false,
  components: {
    'oxd-tree-node': TreeNode,
  },
});
